import { useEffect, useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import {
  Renderer,
  DataProvider,
  VisibilityProvider,
  ActionProvider,
} from '@json-render/react';
import { portalComponentRegistry } from 'src/components/portal/registry';

export default function PortalContentPage() {
  const { portalId } = useParams({ from: '/portal/$portalId/view' });
  const navigate = useNavigate();
  const [response, setResponse] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/portal/${portalId}/data`, { credentials: 'include' })
      .then((res) => {
        if (res.status === 401) {
          navigate({ to: `/portal/${portalId}/login` });
          return null;
        }
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data) setResponse(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [portalId, navigate]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg">Loading portal...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-red-600">Error loading portal: {error}</div>
      </div>
    );
  }

  if (!response?.jsonTree) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-gray-600">No JSON content available</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <DataProvider initialData={response.data}>
        <VisibilityProvider>
          <ActionProvider>
            <Renderer
              tree={response.jsonTree}
              registry={portalComponentRegistry}
            />
          </ActionProvider>
        </VisibilityProvider>
      </DataProvider>
    </div>
  );
}
